var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-badge"},[_c('div',{style:({
      background: _vm.params.color,
      position: 'absolute',
      inset: 0,
      opacity: 0.2,
    })}),_c('i',{staticClass:"darker-color",class:[_vm.params.icon, _vm.params.icon ? 'mr-1': ''],style:({color: _vm.params.color})}),_c('span',{staticClass:"darker-color",style:({color: _vm.params.color})},[_vm._v(_vm._s(_vm.params.text || _vm.params.valueFormatted || _vm.params.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }